import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/**
 * Bank Operation Cell Renderer
 * Muestra operación bancaria y número de operación
 */
@Component({
  selector: 'app-bank-operation-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex flex-col gap-1">
      <span class="text-sm font-semibold text-gray-600 dark:text-gray-300">{{ operation }}</span>
      <span class="text-sm text-gray-500 dark:text-gray-400">{{ operationNumber }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class BankOperationCellRendererComponent implements CellRenderer<any, any> {
  @Input() params!: CellRendererParams<any, any>;

  get operation(): string {
    return this.params?.data?.bankOperation ?? '-';
  }

  get operationNumber(): string {
    return this.params?.data?.bankOperationNumber ?? '-';
  }
}
